<template>
	<div class="circle-progress">
		<svg class="circle-svg" viewBox="0 0 100 50">
			<!-- 1. 外层：灰色点线半圆 -->
			<path class="circle-dash" d="M 5 50 A 45 45 0 0 1 95 50"></path>

			<!-- 2. 蓝色点线进度条 -->
			<path class="circle-dash-progress" d="M 5 50 A 45 45 0 0 1 95 50"
				:style="{ strokeDasharray: `${circumference} 9999`, strokeDashoffset: dashOffset }"></path>

			<!-- 3. 进度终点小圆点标记 -->
			<circle v-if="progress > 0" class="progress-dot" :cx="dotX" :cy="dotY" r="2.5"></circle>

			<!-- 4. 里层：实线底半圆 -->
			<path class="circle-bg" d="M 10 50 A 40 40 0 0 1 90 50"></path>

			<!-- 5. 里层：蓝色实线满环 -->
			<path class="circle-path" d="M 10 50 A 40 40 0 0 1 90 50"></path>
		</svg>

		<!-- 中间文字 -->
		<div class="circle-text">
			<span class="number">{{ number }}</span>
			<span class="unit">所</span>
			<p class="desc">适合我的大学</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: "HalfCircleProgress",
		props: {
			number: {
				type: [Number, String],
				default: 0
			},
			progress: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				radius: 45,
			};
		},
		computed: {
			circumference() {
				return Math.PI * this.radius;
			},
			dashOffset() {
				return this.circumference * (1 - this.progress / 100);
			},
			// 进度点坐标
			dotX() {
				const angle = (180 - this.progress * 1.8) * Math.PI / 180;
				return 50 + 45 * Math.cos(angle);
			},
			dotY() {
				const angle = (180 - this.progress * 1.8) * Math.PI / 180;
				return 50 - 45 * Math.sin(angle);
			},
		},
		mounted() {

		},
		methods: {

		},
	};
</script>

<style scoped>
	.circle-progress {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.circle-svg {
		width: 100%;
		height: 100%;
	}

	/* 灰色 点线 */
	.circle-dash {
		fill: none;
		stroke: #dcdfe6;
		stroke-width: 1.5;
		stroke-dasharray: 1 3;
		/* 点线效果 */
	}

	/* 蓝色 点线进度 */
	.circle-dash-progress {
		fill: none;
		stroke: #28b05e;
		stroke-width: 1.5;
		stroke-dasharray: 1 3;
		/* 点线效果 */
		stroke-linecap: round;
		transition: stroke-dashoffset 0.8s ease;
	}

	/* 进度终点小圆点 */
	.progress-dot {
		fill: #28b05e;
	}

	/* 里层实线底半圆 */
	.circle-bg {
		fill: none;
		stroke: #f5f5f5;
		stroke-width: 6;
	}

	/* 里层蓝色实线满环 */
	.circle-path {
		fill: none;
		stroke: #28b05e;
		stroke-width: 5;
		stroke-linecap: round;
	}

	/* 文字 */
	.circle-text {
		position: absolute;
		top: 80%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
	}

	.number {
		font-size: 30px;
		font-weight: bold;
		color: #333;
	}

	.unit {
		font-size: 16px;
		color: #666;
		margin-left: 4px;
	}

	.desc {
		font-size: 14px;
		color: #999;
		margin: 3px 0 0;
	}
</style>
